import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {DBHeaderLinkConfigDirective, PBHeaderModule} from '@db/db-components';
import { DBButtonModule, DBIconModule } from '@db/db-core';

@Component({
  selector: 'app-header-pb',
  templateUrl: './header-pb.component.html',
  styleUrls: ['./header-pb.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    PBHeaderModule,
    DBButtonModule,
    DBIconModule,
    DBHeaderLinkConfigDirective
  ]
})
export class PbHeaderComponent implements OnInit {

  constructor(private auth: AuthService) {
  }

  get isAuthenticated$() {
    return this.auth.isAuthenticated$;
  }

  ngOnInit() {}

  onLogout() {
    this.auth.logout();
  }
}
